import { IOrcamento } from 'app/types/IOrcamento'
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import clsx from 'clsx'
import { Item } from './Item'
import { IItemOrcamento } from 'app/types/IItemOrcamento'
import { TableHead } from "./head/TableHead";
import { IFilial } from "../../../types/IFilial";
import { ICentroCusto } from "../../../types/ICentroCusto";
import { Ambiente } from 'app/use-cases/orcamento/ambiente/Ambiente'
import globalMU from 'globalMU'
import * as R from 'ramda'
import { IColuna } from 'app/types/IColuna'
import { Parametro, ParametroPorItem } from 'app/types/Parametro'
import { ITipoFaturamento } from 'app/types/ITipoFaturamento'
import { AcoesHead } from './head/AcoesHead'
import { ITipoEntrega } from 'app/types/ITipoEntrega'
import { DataFormatoEN } from 'app/types/DataFormatoEN'
import { CodigoTurnoEntrega } from 'app/types/CodigoTurnoEntrega'
import { CodigoTipoEntrega } from 'app/types/CodigoTipoEntrega'
import Legenda from '../legenda/Legenda'
import { BarraRolagemHorizontalSuperior } from 'app/components/componentes-basicos/BarraRolagemHorizontalSuperior'
import { dispositivoSemHover } from 'app/utils/dispositivoSemHover'
import { obterAlturaCabecalhoFixo } from 'app/utils/alturaCabecalhoFixo'


const estilosTabelas = require('../../../estilos/tabelas.module.scss').default
const estiloGridItens = require('./grid-itens.module.scss').default
import { fonteGradeOuHerdada } from 'app/utils/tamanhoFonteGrid'

export type GridItensContextType = {
    /** Gerais **/
    orcamento: IOrcamento,
    parametrosGridItens: Parametro[],
    parametrosGridItensPorFilial?: ParametroPorItem[], // 469010
    timezone: string,
    tamanhoFontePadrao: number
    onEditarItem: (identificadorItem: number) => void
    /** Exclui SO o item da linha (o botao Excluir da barra de ferramentas exclui os selecionados) */
    onExcluirItem: (item: IItemOrcamento) => void
    onAlterarFonte: (tamanho: number) => void
    onSelecionarItem: (itens: IItemOrcamento) => void
    onMudarObs: (obs: string, item: IItemOrcamento) => void
    agruparPorAmbientes: boolean
    dataMaximaParaPrevisaoEntrega?: { year: number, month: number, day: number }
    /** Quantidade e preço **/
    numeroCasasDecimaisQuantidade: number,
    numeroCasasDecimaisPreco: number,
    numeroCasasDecimaisPrecoTotal: number,
    permiteEngrenagemGrid?: boolean, // 418506
    onQuantidadeModificada: (identificadorItem: number, quantidade: number) => void
    onPrecoModificado: (identificadorItem: number, preco: number, percentualDesconto: number, percentualBonificacao: number) => void
    onPorcentagemDescontoUnitarioModificado: (identificadorItem: number, preco: number, percentualDescontoUnitario: number, preservaDesconto: boolean) => void
    onModificadoPreservarDescontoUnitario: (IdentificadorItem: number, preco: number, percentualDescontoUnitario: number, PreservarDescontoUnitario: boolean) => void
    onPercentualMarkupModificado: (identificadorItem: number, percentualMarkup: number) => void
    /** Filiais **/
    filiaisRetiradaPorItem: { [identificadorItem: number]: IFilial[] },
    filiaisTransferenciaPorItem: { [identificadorItem: number]: IFilial[] },
    onFilialRetiradaAlterada: (filial: string, identificador: number) => void
    onFilialTransferenciaAlterada: (filial: string, identificador: number) => void
    onFocusFilialTransferencia: (identificadorItem: number) => void
    onFocusFilialRetirada: (identificadorItem: number) => void
    /** Colunas **/
    onToggleColunaSelecionada: (nomeColuna: string, selecionada: boolean) => void
    colunas: IColuna[],

    /** Ambientes */
    onAmbienteSelecionado: (ambiente: Ambiente, identificadorItem: number) => void
    onExcluirAmbiente: (ambiente: Ambiente, identificadorItem: number) => void
    onSalvarAmbiente: (ambiente: Ambiente, identificadorItem: number) => void
    ambientes: Ambiente[]
    proximaCorAmbiente: string
    toggleLimparNovoAmbiente: string

    /** Faturamento **/
    onFaturamentoAlterado: (tipoFaturamento: string, identificadorItem: number) => void

    /** Servico Agregado ao produto**/
    onRemoverServicoAgregado: (identificadorItem: number) => void

    /**Pedido de compra **/
    onEditarPedidoDeCompra: (identificador: number, pedidoCompra: string) => void

    onBuscarOuInformarCentroCusto: (nomeParcialCentroCusto: string, identificadorItem: number) => void
    centrosCusto: ICentroCusto[]

    exibirIconeReservaLoteSePossivel: boolean
    permitirVisualizarSimulacaoDePreco: boolean //457575
    onSimularPreco: (identificadorItem: number) => void //457575
    onAlterarCorTintometricoSimplificado: (identificadorItem: number) => void // PA 402355 repasse 311033
    onAlterarCorTintometrico: (identificadorItem: number) => void //455868
    onMostrarInformacoesProduto: (identificadorItem: number) => void

    onMostrarImagens: (identificadorItem: number, classeElementoAncora: string) => void

    onReservarLote: (identificadorItem: number) => void

    tiposFaturamento: ITipoFaturamento[]
    produtosFazemParteCampanhaCupomDesconto: string[]

    onEditarLinhaOrdemPedidoCompraItem: (identificadorItem: number, linhaOrdemCompra: string) => void
    desativarEdicaoOrdemPedidoCompraItem: boolean

    onToggleSelecionarTodasColunas: (selecionar: boolean) => void

    corItemSelecionado: string

    onAlterarEntregaPosterior: (check: boolean, item: IItemOrcamento) => void
    onAlterarMostruario: (check: boolean, item: IItemOrcamento) => void // PA 487087
    onAlterarPrioridadeMontagem: (check: boolean, identificadorItem: number) => void //456839

    onAlterarVendaSobEncomenda: (check: boolean, identificadorItem: number, item: IItemOrcamento) => void
    onAlterarEncomendaExpressa: (check: boolean, identificadorItem: number, item: IItemOrcamento) => void //433263


    tiposFreteDisponiveisPorItem: {
        [key: number]: {
            IdTipoFrete?: number
            EhFreteEspecial?: boolean
            Descricao?: string
        }[]
    }

    desativarCheckboxesVendaSobEncomendaItens: boolean
    desativarCheckboxVendaEncomendaExpressaItens: boolean // 433263
    exibirTextoTecnico: boolean
    tiposEntrega: ITipoEntrega[];
    onTipoEntregaAlterada: (codigoTipoEntrega: CodigoTipoEntrega, identificadorItem: number) => void;

    onDataPrevistaAlterada: (dataPrevisaoEntrega: DataFormatoEN, identificadorItem: number) => void;
    onDataMarcadaAlterada: (dataMarcadaEntrega: DataFormatoEN, identificadorItem: number) => void;
    onTurnoAlterada: (turnoEntrega: CodigoTurnoEntrega, identificadorItem: number) => void;

}

export const GridItensContext = React.createContext<GridItensContextType>({
    orcamento: {} as IOrcamento,
    parametrosGridItens: [],
    timezone: "",
    tamanhoFontePadrao: 0,
    onEditarItem: () => { },
    onExcluirItem: () => { },
    onAlterarFonte: () => { },
    onSelecionarItem: () => { },
    onMudarObs: () => { },
    agruparPorAmbientes: false,
    numeroCasasDecimaisQuantidade: 0,
    numeroCasasDecimaisPreco: 0,
    numeroCasasDecimaisPrecoTotal: 0,
    onQuantidadeModificada: () => { },
    onPrecoModificado: () => { },
    onPorcentagemDescontoUnitarioModificado: () => { },
    onModificadoPreservarDescontoUnitario: () => { },
    onPercentualMarkupModificado: () => { },
    filiaisRetiradaPorItem: {},
    filiaisTransferenciaPorItem: {},
    onFilialRetiradaAlterada: () => { },
    onFilialTransferenciaAlterada: () => { },
    onFocusFilialTransferencia: () => { },
    onFocusFilialRetirada: () => { },
    onToggleColunaSelecionada: () => { },
    colunas: [],
    onAmbienteSelecionado: () => { },
    onExcluirAmbiente: () => { },
    onSalvarAmbiente: () => { },
    ambientes: [],
    proximaCorAmbiente: "",
    toggleLimparNovoAmbiente: "",
    onFaturamentoAlterado: () => { },
    onRemoverServicoAgregado: () => { },
    onEditarPedidoDeCompra: () => { },
    onBuscarOuInformarCentroCusto: () => { },
    centrosCusto: [],
    exibirIconeReservaLoteSePossivel: false,
    permitirVisualizarSimulacaoDePreco: false,
    onSimularPreco: () => { },
    onAlterarCorTintometricoSimplificado: () => { },
    onAlterarCorTintometrico: () => { },
    onMostrarInformacoesProduto: () => { },
    onMostrarImagens: () => { },
    onReservarLote: () => { },
    tiposFaturamento: [],
    produtosFazemParteCampanhaCupomDesconto: [],
    onEditarLinhaOrdemPedidoCompraItem: () => { },
    desativarEdicaoOrdemPedidoCompraItem: false,
    onToggleSelecionarTodasColunas: () => { },
    corItemSelecionado: "",
    onAlterarEntregaPosterior: () => { },
    onAlterarMostruario: () => { }, // PA 487087
    onAlterarPrioridadeMontagem: () => { },
    onAlterarVendaSobEncomenda: () => { },
    onAlterarEncomendaExpressa: () => { },
    tiposFreteDisponiveisPorItem: {},
    desativarCheckboxesVendaSobEncomendaItens: false,
    desativarCheckboxVendaEncomendaExpressaItens: false,
    exibirTextoTecnico: false,
    tiposEntrega: [],
    onTipoEntregaAlterada: () => { },
    onDataPrevistaAlterada: () => { },
    onDataMarcadaAlterada: () => { },
    onTurnoAlterada: () => { },
})

const LegendasGridItens = React.memo(({ parametrosGridItens }: { parametrosGridItens: Parametro[] }) => {
    const legendaItens = [
        { nome: "Produto Em Oferta", cor: "var(--mu-azul-marcador, #0000FF)" },
        { nome: "Sob Encomenda", cor: "#EC780F" },
        { nome: "Fora de Linha", cor: "#00C800" },
        { nome: "Fora do Mix", cor: "#800000" },
        { nome: "Entrega Inválida", cor: "#FF0080" },
        { nome: "Possui Agregado", cor: "#808000" },
        { nome: "Em Oferta com Agregado", cor: "#400080" },
    ]
    if ((parametrosGridItens ?? []).find(p => p.Nome == "DESTACAR_PRODUTOS_COM_RETIRADA_CD_ORCAMENTO")?.Valor === "S")
        legendaItens.push({ nome: "Retirado no Centro de Distribuição", cor: "#FF8080" })
    legendaItens.push({ nome: "Produto Não Aceita Devolução", cor: "#FFFF00" })
    legendaItens.push({ nome: "Produto Importado", cor: "#1c8a3c" })
    legendaItens.push({ nome: "Saldão", cor: "#AB2DE1" })
    if ((parametrosGridItens ?? []).find(p => p.Nome == "UTILIZA_CONTROLE_PRODUCAO")?.Valor === "S")
        legendaItens.push({ nome: "Fabricação Própria", cor: "#7E7E7E" })
    if ((parametrosGridItens ?? []).find(p => p.Nome == "UTILIZA_ETIQUETA_PESAGEM_VENDA")?.Valor === "S")
        legendaItens.push({ nome: "Etiqueta Embalagem Avulsa", cor: "#464646" })
    return <Legenda itens={legendaItens} />
})


const obterChaveItem = (item: IItemOrcamento, mapIndex: number): string =>
    item.Identificador != null ? `item_${item.Identificador.toString()}`
        : item.Index != null ? `item_dataIdx_${item.Index.toString()}_mapIdx_${mapIndex}`
            : `item_mapIdx_${mapIndex}`

const renderizarItem = ({ indexItem, item, key, exibirAcoesFlutuantesTouch, onLinhaClicada, onToggleExpandirItem, onMenuAmbientesAberto, ocultarAcoesFlutuantes, onExibicaoMenuAmbientesAlterada, onMouseSobreMenuAmbientes }:
    {
        indexItem: number, item: IItemOrcamento, key: string,
        exibirAcoesFlutuantesTouch: boolean, onLinhaClicada: () => void,
        onToggleExpandirItem: () => void, onMenuAmbientesAberto: (larguraContainer: number) => void,
        ocultarAcoesFlutuantes: boolean, onExibicaoMenuAmbientesAlterada: (exibindo: boolean) => void,
        onMouseSobreMenuAmbientes: (sobre: boolean) => void
    }) => {
    return (
        <Item
            item={item}
            key={key}
            indexItem={indexItem}
            exibirAcoesFlutuantesTouch={exibirAcoesFlutuantesTouch}
            onLinhaClicada={onLinhaClicada}
            onExpandirSubItensClicado={() => {
                onToggleExpandirItem()
            }}
            onMenuAmbientesAberto={onMenuAmbientesAberto}
            ocultarAcoesFlutuantes={ocultarAcoesFlutuantes}
            onExibicaoMenuAmbientesAlterada={onExibicaoMenuAmbientesAlterada}
            onMouseSobreMenuAmbientes={onMouseSobreMenuAmbientes}
        />
    )
}

export const GridItens = () => {
    
    const props = useContext(GridItensContext)
    const isMounted = useRef<boolean>(true)
    const [itensExpandidos, setItensExpandidos] = useState<{ [key: number]: boolean }>({})
    // 491123 — em tablet/celular (sem :hover de verdade) o painel de ações flutuante aparece pela
    // linha ter sido tocada, e não pelo item estar selecionado: como a seleção é múltipla, usar
    // `item.selecionado` fazia o painel aparecer em TODAS as linhas selecionadas de uma vez. Guarda
    // a chave da ÚLTIMA linha clicada para que só ela exiba o painel (ver grid-itens.module.scss,
    // bloco "@media (hover: none)"). Em desktop este estado não tem efeito nenhum — lá vale o :hover.
    const [chaveLinhaAcoesFlutuantes, setChaveLinhaAcoesFlutuantes] = useState<string | null>(null)
    const [linhasComMenuAmbienteAberto, setLinhasComMenuAmbienteAberto] = useState<string[]>([])
    const [chaveLinhaMenuSobMouse, setChaveLinhaMenuSobMouse] = useState<string | null>(null)
    const refContainer1Tabela = useRef<HTMLDivElement>(null)
    const refContainer2Tabela = useRef<HTMLDivElement>(null)

    useEffect(() => () => { isMounted.current = false }, [])

    const toggleExpandirItem = useCallback((identificador: number) => {
        if (!isMounted.current) return
        setItensExpandidos(prev => {
            const novos = { ...prev }
            if (identificador in novos) {
                delete novos[identificador]
            } else {
                novos[identificador] = !prev[identificador]
            }
            return novos
        })
    }, [])


    const itemSeraExibido = (item: IItemOrcamento): boolean => {
        if (!isMounted.current) return false;
        const itemPai = R.memoizeWith(() => "", () => props.orcamento.ItensOrcamento.find(i => i.CodigoTinta == item.CodigoTinta && i.PossuiSubItens))

        const itemPaiExpandido = () => itemPai() == null ? false : itemPai().Identificador in itensExpandidos

        return item.PossuiSubItens ? true :
            itemPai() == null ? true :
                itemPai() != null && itemPaiExpandido() ? true :
                    false
    }

    const calcularTotalItens = (itens: IItemOrcamento[]) => R.sum(itens.map(i => i.PrecoTotal))



    const obterTabela = (ambiente: Ambiente | null, uniqueInstanceId: string) => {
        if (!isMounted.current) return null;

        const saneHtmlIdPart = uniqueInstanceId.replace(/[^a-zA-Z0-9-_]/g, '_'); // Para IDs HTML válidos

        const headerAmbienteIndefinido = props.agruparPorAmbientes &&
            ambiente == null &&
            (props.orcamento.ItensOrcamento ?? []).some(i => globalMU.isNotNullOrEmpty(i.Ambiente)) ?
            <span className="_text-2xl _font-bold" style={{ color: "#c4c4c4" }}>Não definido</span> : <></>

        const headerNomeAmbiente = props.agruparPorAmbientes &&
            ambiente != null ? <span style={{ color: ambiente.cor }} className="_text-2xl _font-bold">
            {ambiente.nome}
        </span> : <></>

        const itensExibidos = (props.orcamento?.ItensOrcamento || [])
            .filter(itemSeraExibido)
            .filter(i => !props.agruparPorAmbientes ? true :
                props.agruparPorAmbientes && ambiente == null ? globalMU.isNullOrEmpty(i.Ambiente) :
                    i.Ambiente == (ambiente as Ambiente)?.nome)

        return <div
            key={`div_tbl_wrap_${uniqueInstanceId}`}
            id={`div_tbl_wrap_id_${saneHtmlIdPart}`}
        //style={{marginRight: "10px"}} 
        >
            {headerAmbienteIndefinido}

            {headerNomeAmbiente}

            <table
                id="grid-itens" // nao mudar
                key={`tbl_key_${uniqueInstanceId}`}
                className={clsx(estilosTabelas.tabela, estiloGridItens.tabelaGridItens)}
            >

                <TableHead />


                <tbody style={{ fontSize: fonteGradeOuHerdada(props.tamanhoFontePadrao) }}
                    id={`tbody_id_${saneHtmlIdPart}`}
                    key={`tbody_key_${uniqueInstanceId}`}
                >
                    {
                        itensExibidos
                            .map((item, map_item_index) => { // ALTERADO: 'key' do map para 'map_item_index'
                                const reactForItemKey = obterChaveItem(item, map_item_index);

                                const chaveLinhaAcima = map_item_index > 0
                                    ? obterChaveItem(itensExibidos[map_item_index - 1], map_item_index - 1)
                                    : null;
                                const cobririaOMenuDe = (chave: string | null) => chave != null
                                    && linhasComMenuAmbienteAberto.includes(chave)
                                    && chaveLinhaMenuSobMouse === chave;
                                const ocultarAcoesFlutuantes =
                                    cobririaOMenuDe(reactForItemKey) || cobririaOMenuDe(chaveLinhaAcima);

                                return renderizarItem({
                                    indexItem: map_item_index, // Usando map_item_index
                                    item,
                                    key: reactForItemKey, // ALTERADO: Chave para o Fragmento/Item
                                    exibirAcoesFlutuantesTouch: chaveLinhaAcoesFlutuantes === reactForItemKey, // 491123
                                    onLinhaClicada: () => { // 491123
                                        if (dispositivoSemHover())
                                            setChaveLinhaAcoesFlutuantes(reactForItemKey)
                                    },
                                    onToggleExpandirItem: () => toggleExpandirItem(item.Identificador),
                                    ocultarAcoesFlutuantes, // 493643
                                    onMouseSobreMenuAmbientes: (sobre) => setChaveLinhaMenuSobMouse(prev => // 493643
                                        sobre ? reactForItemKey : (prev === reactForItemKey ? null : prev)),
                                    onExibicaoMenuAmbientesAlterada: (exibindo) => setLinhasComMenuAmbienteAberto(prev => // 493643
                                        exibindo
                                            ? (prev.includes(reactForItemKey) ? prev : [...prev, reactForItemKey])
                                            : prev.filter(chave => chave !== reactForItemKey)),
                                    onMenuAmbientesAberto: (larguraContainer) => {
                                        setTimeout(() => {
                                            if (refContainer1Tabela.current) { // Mantendo a verificação original se existia
                                                refContainer1Tabela.current.scrollLeft += larguraContainer
                                            }
                                        }, 500)
                                    }
                                });
                            })
                    }

                </tbody>

                {props.agruparPorAmbientes
                    && <tfoot
                        id={`tfoot_id_${saneHtmlIdPart}`}
                        key={`tfoot_key_${uniqueInstanceId}`}
                    >
                        <tr
                            id={`tfoot_tr_id_${saneHtmlIdPart}`}
                            key={`tfoot_tr_key_${uniqueInstanceId}`}
                        >
                            <td colSpan={props.colunas?.length + 1} // Mantendo colSpan original
                                id={`tfoot_td1_id_${saneHtmlIdPart}`}
                                key={`tfoot_td1_key_${uniqueInstanceId}`}
                            >
                                <span className="_font-bold"
                                    id={`tfoot_td1_span1_id_${saneHtmlIdPart}`}
                                    key={`tfoot_td1_span1_key_${uniqueInstanceId}`}
                                >
                                    Total
                                </span>
                            </td>
                            <td
                                id={`tfoot_td2_id_${saneHtmlIdPart}`}
                                key={`tfoot_td2_key_${uniqueInstanceId}`}
                            >
                                <span className="_font-bold"
                                    id={`tfoot_td2_span2_id_${saneHtmlIdPart}`}
                                    key={`tfoot_td2_span2_key_${uniqueInstanceId}`}
                                >
                                    R$ {globalMU.formatarValorNumerico(
                                        calcularTotalItens( // Mantendo lógica original de filtro para calcularTotalItens
                                            (props.orcamento?.ItensOrcamento ?? []).filter(i => ambiente == null && globalMU.isNullOrEmpty(i.Ambiente) ? true : i.Ambiente == (ambiente as Ambiente)?.nome)
                                        ),
                                        props.numeroCasasDecimaisPreco
                                    )}
                                </span>
                            </td>
                        </tr>
                    </tfoot>}
            </table>
        </div>
    }


    return <>

        <AcoesHead
            id="AcoesHead_GridItens"
            onToggleColunaSelecionada={props.onToggleColunaSelecionada}
            onAlterarFonte={props.onAlterarFonte}
            tamanhoFonte={props.tamanhoFontePadrao}
            colunas={props.colunas}
            codigoFilialOrcamento={props.orcamento.CodigoFilialOrcamento}
            onToggleSelecionarTodasColunas={props.onToggleSelecionarTodasColunas}
            parametro_CHAVE_MOVIMENTACAO_ORCAMENTO={((props.parametrosGridItens ?? []).find(p => p.Nome == "CHAVE_MOVIMENTACAO_ORCAMENTO")?.Valor ?? "R") as "C" | "R"}
            permiteEngrenagemGrid={props.permiteEngrenagemGrid ?? false}
            aviso={!props.orcamento.SomenteLeitura && props.orcamento.EditandoSemRecalcular ? "Os Preços dos Itens Não Foram Recalculados" : null} // 455487
        />

        {/* 493427 — a barra nativa fica na base do container; com a grade alta, essa base cai
            abaixo da janela e a barra fica inalcançável. Esta é a mesma rolagem, no topo. */}
        <BarraRolagemHorizontalSuperior
            referenciaContainerRolavel={refContainer2Tabela}
            quantidadeDeLinhas={(props.orcamento.ItensOrcamento ?? []).length}
            obterDeslocamentoSuperior={obterAlturaCabecalhoFixo}
            id="container-rolavel-grid-itens_BarraRolagemSuperior"
        />

        <div
            className={clsx(
                estiloGridItens.containerGrid,
                // 491123 — com só 1 linha, o painel flutuante da 1ª linha (que desce, ver #211)
                // não tem uma 2ª linha para ocupar e ficava cortado pelo overflow do container
                (props.orcamento.ItensOrcamento ?? []).length === 1 && estiloGridItens.containerGridUmaLinha
            )}
            id="container-rolavel-grid-itens"
            key="container-rolavel-grid-itens"
            ref={refContainer2Tabela}
        >

            <div ref={refContainer1Tabela}
                id="container-rolavel-grid-itens_Container1Tabela" // CORRIGIDO: Removido '}' do ID
                key="container-rolavel-grid-itens_Container1Tabela"
            >

                {/* ALTERADO: Chamadas a obterTabela com uniqueInstanceId */}
                {props.agruparPorAmbientes && (props.orcamento.ItensOrcamento ?? []).some(i => globalMU.isNullOrEmpty(i.Ambiente)) && obterTabela(null, "no_ambiente_section")}

                {props.agruparPorAmbientes && props.ambientes.map((ambiente, index_map) => {
                    // Tenta usar ambiente.id (ou variações comuns), depois ambiente.nome, depois índice do map
                    const ambIdProp = (ambiente as any).id ?? (ambiente as any).Id ?? (ambiente as any).Oid ?? (ambiente as any).IdOid ?? (ambiente as any).identificador;
                    const ambIdentifier = ambIdProp?.toString() ?? ambiente.nome ?? `mapidx_${index_map}`;
                    return obterTabela(ambiente, `amb_${ambIdentifier}`);
                })}

                {!props.agruparPorAmbientes && obterTabela(null, "all_items_section")}
            </div>


        </div>

        <LegendasGridItens parametrosGridItens={props.parametrosGridItens} />

        {<section style={{ marginBottom: "100px" }} />}

    </>
}
